import { render, staticRenderFns } from "./QuoteEmailAttachmentViewerModal.vue?vue&type=template&id=52ca0d6c"
import script from "./QuoteEmailAttachmentViewerModal.vue?vue&type=script&lang=js"
export * from "./QuoteEmailAttachmentViewerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ca0d6c')) {
      api.createRecord('52ca0d6c', component.options)
    } else {
      api.reload('52ca0d6c', component.options)
    }
    module.hot.accept("./QuoteEmailAttachmentViewerModal.vue?vue&type=template&id=52ca0d6c", function () {
      api.rerender('52ca0d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteEmailAttachmentViewerModal.vue"
export default component.exports